import gql from 'graphql-tag';

// This fragment is make to be used for MainPaycheckLineTemplateForm
export const mainPaycheckLineTemplateFormFragment = gql`
  fragment mainPaycheckLineTemplateFormFragment on MainPaycheckLineTemplate {
    id
    active
    altinnDescription
    altinnFordel
    calculatePositive
    calculationType
    car {
      id
      name
    }
    carOverwrite
    department {
      id
      name
    }
    departmentOverwrite
    description
    editableFromEmployeePage
    employerTaxable
    includeInVacationMoneyBase
    number
    taxDeduction
    taxDeductionVoluntary
    project {
      id
      name
    }
    projectOverwrite
    quantity
    rate
    sum
    taxable
    garnishment
    garnishmentSamordnet
    vacationMoneyEarnedInPreviousYear
    vacationMoneyEarnedInCurrentYear
  }
`;

export const UNIT_MAIN_PAYCHECK_LINE_TEMPLATES = gql`
  query unitMainPaycheckLineTemplates {
    currentUnit {
      id
      mainPaycheckLineTemplates {
        ...mainPaycheckLineTemplateFormFragment
      }
    }
  }
  ${mainPaycheckLineTemplateFormFragment}
`;

export const SAVE_MAIN_PAYCHECK_LINE_TEMPLATE = gql`
  mutation saveMainPaycheckLineTemplate(
    $mainPaycheckLineTemplates: [MainPaycheckLineTemplateSave!]!,
    $unitId: ID,
  ) {
    saveMainPaycheckLineTemplate(
      input: {
        mainPaycheckLineTemplates: $mainPaycheckLineTemplates,
        unitId: $unitId,
      }
    ) {
      mainPaycheckLineTemplates {
        ...mainPaycheckLineTemplateFormFragment
      }
    }
  },
  ${mainPaycheckLineTemplateFormFragment}
`;
